/**
 * TherapieMaps reference data — loaded via GET /api/reference/clinics.
 *
 * The API reads therapiemapsstorage server-side (Managed Identity). The browser
 * never touches blob storage or SAS tokens for clinic/CM/HoRO mappings.
 *
 * Returns lookup maps used across the app:
 *   clinics, clinicByEmail, clinicByName, cms, cmByMail, horos, horoByMail
 */

import { apiFetch } from './apiFetch.js';

let _cache = null;

/**
 * @param {{ accessToken?: string, force?: boolean }} [opts]
 *   accessToken — pass during Auth bootstrap before App registers the token provider
 */
export async function getTherapieMapsData({ accessToken, force = false } = {}) {
  if (!force && _cache) return _cache;

  const data = await apiFetch('/api/reference/clinics', { accessToken });

  _cache = {
    clinics:       data.clinics       || [],
    clinicByEmail: data.clinicByEmail || {},
    clinicByName:  data.clinicByName  || {},
    cms:           data.cms           || [],
    ams:           data.ams           || [],
    cmByMail:      data.cmByMail      || {},
    amByMail:      data.amByMail      || {},
    horos:         data.horos         || [],
    horoByMail:    data.horoByMail    || {},
    scope:         data.scope         || null,
    assignment:    data.assignment    || null,
    loadedAt:      data.loadedAt      || null,
  };

  console.log(
    `[TherapieMaps] Loaded ${_cache.clinics.length} clinics (API), ` +
    `${_cache.cms.length} CMs, ${_cache.horos.length} HoROs`,
  );

  return _cache;
}

/** Force a fresh fetch on the next call to getTherapieMapsData(). */
export function clearTherapieMapsCache() {
  _cache = null;
}
